<template>
	<mdb-navbar class="mb-1 navbar navbar-expand-xl w-100" hamburger>
			<mdb-col col="2" md="2" class="d-none d-lg-block"/>

			<mdb-col>
				<mdb-navbar-brand class="float-left">
					<a href="/">
						<img src="@/assets/logo.png" height=60 alt="">
					</a>
				</mdb-navbar-brand>

				
				<mdb-navbar-toggler class="mt-2">
					<mdb-navbar-nav>
						
						<mdb-nav-item href="/#/services" class="linkUnderlines foxDownBlue">
							Services
						</mdb-nav-item>
						
						<mdb-nav-item href="/#/projects" class="linkUnderlines foxDownBlue">
							Projects
						</mdb-nav-item>
						
						<mdb-nav-item href="/#/hands" class="linkUnderlines foxDownBlue">
							Health &amp; Safety
						</mdb-nav-item>
						
						<mdb-nav-item href="/#/contact" class="linkUnderlines foxDownBlue">
							Contact
						</mdb-nav-item>
					</mdb-navbar-nav>

					<span class="navbar-text pr-3 foxDownBlue">
						<a class="navEmail" href="mailto:admin@foxdownconstruction.co.uk">
						<mdb-icon far icon="envelope" class="pr-1" />
						admin@foxdownconstruction.co.uk
						</a>
					</span>


					<span class="navbar-text mr-3 foxDownBlue">
						<mdb-icon icon="phone" class="pr-1" />
						01825 749389
					</span>
					
					<a class="fb-ic mr-3" role="button" href="https://www.facebook.com/FoxdownConstructionLtd/"><i class="fab fa-facebook-f foxDownBlue"></i></a>
					<a class="li-ic mr-3" role="button" href="https://www.linkedin.com/company/foxdown-construction-ltd/"><i class="fab fa-linkedin foxDownBlue"></i></a>
					<a class="ins-ic mr-3" role="button" href="https://www.instagram.com/foxdownconstructionltd"><i class="fab fa-instagram foxDownBlue"></i></a>
					
					
				</mdb-navbar-toggler>
			</mdb-col>
			<mdb-col col="2" md="2" class="d-none d-lg-block"/>
			</mdb-navbar>
</template>

<script>
import { mdbCol, mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem,  mdbIcon } from 'mdbvue';
export default {
  name: 'Navbar',
  components: {
		mdbCol,
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbIcon,
    }
};

</script>

